import * as React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@avensia/excite';
import { BackIcon } from 'webapp/components/icons';
import { isSvenssons, Theme } from 'webapp/theme';
import { createFieldSizeDecorator, FieldSize } from 'webapp/components/field-size';
import { Button } from 'webapp/components/button';

export enum TabsType {
  Products,
  Others,
}

type Props = {
  onClick: (tab: TabsType) => void;
  selectedTab: TabsType;
  popLevel: () => void;
  isRootLevel: boolean;
  isProductRootLevel: boolean;
};

export const Tabs = ({ selectedTab, onClick, isRootLevel, isProductRootLevel, popLevel }: Props) => {
  const navigateProductsBack = !isProductRootLevel && selectedTab === TabsType.Products;
  const navigateOthersBack = !isRootLevel && selectedTab === TabsType.Others;
  return (
    <Base>
      <Tab
        as={Theme.White}
        disableRippleEffect
        css={createBackgroundColorDecorator(selectedTab === TabsType.Products)}
        onClick={() => {
          navigateProductsBack ? popLevel() : onClick(TabsType.Products);
        }}
      >
        {navigateProductsBack ? (
          <>
            <BackArrow /> {translate(t => t.mobileMenu.navigateBack)}
          </>
        ) : (
          translate(t => t.mobileMenu.products)
        )}
      </Tab>
      <Tab
        as={Theme.White}
        disableRippleEffect
        css={createBackgroundColorDecorator(selectedTab === TabsType.Others)}
        onClick={() => {
          navigateOthersBack ? popLevel() : onClick(TabsType.Others);
        }}
      >
        {navigateOthersBack ? (
          <>
            <BackArrow /> {translate(t => t.mobileMenu.navigateBack)}
          </>
        ) : (
          translate(t => t.mobileMenu.misc)
        )}
      </Tab>
    </Base>
  );
};

const Base = styled.div(
  {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
  },
  isSvenssons && {
    border: { y: { style: 'solid', width: 1, color: t => t.mobileMenu?.borderColor } },
  },
);

const BackArrow = styled(BackIcon, {
  fontSize: t => t.fontSize.xxs,
  marginRight: t => t.spacing.xxs,
});

const Tab = styled(
  Button,
  createFieldSizeDecorator(FieldSize.Default),
  {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: t => t.mobileMenu?.tabs?.fontFamily,
    fontSize: t => t.mobileMenu?.tabs?.fontSize,
    fontWeight: t => t.mobileMenu?.tabs?.fontWeight,
    transition: { duration: 300, property: 'background-color' },
    textTransform: t => t.mobileMenu?.tabs?.textTransform,
    border: { xy: { width: 0 } },
    padding: { y: t => t.sharedSpacing.s },
    ':focus-visible': {
      outlineOffset: -2,
    },
  },
  isSvenssons && {
    textTransform: 'uppercase',
    ':first-child': {
      border: { right: { style: 'solid', width: 1, color: t => t.mobileMenu?.borderColor } },
    },
  },
);

function createBackgroundColorDecorator(selected: boolean) {
  return styled({ backgroundColor: selected ? t => t.mobileMenu?.backgroundColor : t => t.mobileMenu?.accentColor });
}
